<template>
  <div
    class="modal fade"
    :class="{ show: show }"
    :style="{ display: show ? 'block' : 'none' }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content rounded-3">
        <!-- Body -->
        <div class="modal-body d-flex flex-column" style="gap: 32px">
          <div>
            <div class="d-flex justify-content-between">
              <h5 class="fw-bold">Suspend User</h5>
              <button
                type="button"
                class="btn-close"
                @click="$emit('close')"
              ></button>
            </div>
            <p>
              Are you sure you want to suspend {{ user?.fullname }}? They will
              no longer be able to access the dashboard until reactivated.
            </p>
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="$emit('close')"
            >
              Cancel
            </button>
            <button type="button" class="btn btn-danger" @click="suspend">
              Suspend
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { suspendUser } from "@/api/user-management";

export default {
  name: "SuspendUserModalComponent",
  props: {
    show: Boolean,
    user: Object,
  },
  methods: {
    async suspend() {
      try {
        const response = await suspendUser(this.user.id);

        if (response && response.status === "success") {
          this.$emit("suspended", response.data); // emit ke parent biar bisa refresh list
          this.$swal(
            "Success!",
            "User has been suspended successfully!",
            "success"
          );
        } else {
          this.$swal(
            "Error",
            response?.message || "Failed to suspend user",
            "error"
          );
        }
      } catch (error) {
        console.error("Error suspending user:", error);
        this.$swal(
          "Error",
          "Something went wrong while suspending user",
          "error"
        );
      } finally {
        this.$emit("close");
      }
    },
  },
};
</script>
